import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useScrolled } from './useScrolled';

export const useHeaderNavigation = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const scrolled = useScrolled(30);

  useEffect(() => { setMobileOpen(false); }, [pathname]);
  useEffect(() => {
    if (!mobileOpen) return undefined;
    const onKey = (event) => { if (event.key === 'Escape') setMobileOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [mobileOpen]);

  return {
    solid: scrolled || pathname !== '/', mobileOpen,
    toggleMenu: () => setMobileOpen((current) => !current),
    requestQuote: () => { setMobileOpen(false); navigate('/iletisim'); },
  };
};